import { message } from 'antd';
import React, { createContext, useReducer, useEffect } from 'react';
import { io } from 'socket.io-client';
import Parse from 'parse';
import done from '../components/base64/';
import axios from 'axios';

const QRCodeContext = createContext();

const qrCodeReducer = (state, action) => {
    switch (action.type) {
        case 'SET_QR_CODE':
            return { ...state, qrCode: action.payload };
        case 'LOADING':
            return { ...state, loading: action.payload };
        case 'SESSION':
            return { ...state, uid: action.payload };
        case 'ONLINE':
            return { ...state, online: action.payload };
        default:
            return state;
    }
};

const initialState = {
    qrCode: null,
    loading: true,
    uid: localStorage.getItem('uid')
};

const startSocket = (accountId, dispatch) => {
    const socketInstance = io('https://wa.coolendy.net');
    socketInstance.once('connect', () => {
        console.log('Connected:', socketInstance.id);
        socketInstance.emit('join-channel', accountId); // Join the channel based on userId
    });

    socketInstance.on('disconnect', (reason) => {
        console.log('Disconnected:', reason);
    });

    socketInstance.on('connect_error', (error) => {
        console.error('Connection Error:', error);
    });

    socketInstance.on('qr', (data) => {
        console.log({data})
        dispatch({ type: 'SET_QR_CODE', payload: data.qr });
        dispatch({ type: 'LOADING', payload: false });
        dispatch({ type: 'ONLINE', payload: undefined });
    });

    socketInstance.on('status', (data) => {
        console.log({data})
        if (data.status === 'Online') {
            dispatch({ type: 'SET_QR_CODE', payload: done });
            dispatch({ type: 'ONLINE', payload: true });
        }
        dispatch({ type: 'LOADING', payload: false });
    });

    socketInstance.on('reconnect', () => {        
        dispatch({ type: 'ONLINE', payload: false });
        dispatch({ type: 'LOADING', payload: true });
        dispatch({ type: 'ONLINE', payload: undefined });
       /*  loadQr(accountId).then(data => {
            if (data.error) throw Error(data.error)
            dispatch({ type: 'SET_QR_CODE', payload: data.qr });
            // dispatch({ type: 'LOADING', payload: false });
        }).catch(function (error) {
            message.error('Error fetching QR code:' + error.message);
            dispatch({ type: 'LOADING', payload: false });
        }) */
    });

}

const handleLogin = async (values) => {
    const { username, password } = values;
    const result = await Parse.Cloud.run('validatePassword', { username, password });
    message.success(result.id)
    localStorage.setItem('uid', result.id)
    return result.id

};


const loadQr = async (accountId) => {
    const response = await axios.post('https://wa.coolendy.net/generate-qrcode', { accountId }, {
        headers: {
            "Content-Type": "application/json"
        }
    });
    const { data } = response
    return data;
}

const QRCodeProvider = ({ children }) => {
    const [state, dispatch] = useReducer(qrCodeReducer, initialState);
    Parse.initialize(process.env.REACT_APP_PARSE_APP_ID, process.env.REACT_APP_PARSE_JS_KEY);
    Parse.serverURL = process.env.REACT_APP_PARSE_SERVER_URL;
    const fetchQRCode = async () => {
        const { uid } = state;
        startSocket(uid, dispatch)
        try {
            const data = await loadQr(uid)
            if (data.error) throw Error(data.error)
            dispatch({ type: 'SET_QR_CODE', payload: data.status ? done : data.qr });
            dispatch({ type: 'ONLINE', payload: data.status });
            dispatch({ type: 'LOADING', payload: false });
        } catch (error) {
            message.error('Error fetching QR code:' + error.message);
            dispatch({ type: 'LOADING', payload: false });
        }

    };

    useEffect(() => {
        if (state.uid) {
            fetchQRCode();
        } else {
            dispatch({ type: 'LOADING', payload: false });
        }
    }, [state.uid]);

    return (
        <QRCodeContext.Provider value={{ state, dispatch }}>
            {children}
        </QRCodeContext.Provider>
    );
};

export { QRCodeContext, QRCodeProvider, loadQr, handleLogin };
